import { jsx } from "react/jsx-runtime";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { validateTidalLicense } from "../../base/index.js";
function PlayCircleOutline(props) {
  return /* @__PURE__ */ jsx(
    PlayCircleOutlineIcon,
    {
      "data-testid": "PlayCircleOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PlayCircleOutline",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
PlayCircleOutline.tidalIconMeta = {
  categories: "cancel,informative",
  name: "PlayCircleOutline"
};
validateTidalLicense();
export {
  PlayCircleOutline
};
//# sourceMappingURL=PlayCircleOutline.js.map
